module.exports = __webpack_public_path__ + "img/ic_flat_upper.a8ef928b.svg";